const { printDocument } = require("../APIs/PrintersAPI");
const { resolveProductPrinterTargets } = require("../utils/kitchenWorkflow");

const buildTargetsFromOrderItems = (items = [], roomId = null) => {
    const linesByPrinter = new Map();
    const unassigned = [];

    for (const tp of items) {
        if (!tp?.product?.name) continue;
        const line = `${tp.product.name}     x${tp.quantity}`;
        const printerTargets = resolveProductPrinterTargets(tp.product, roomId);
        if (!printerTargets.length) {
            unassigned.push(line);
            continue;
        }
        printerTargets.forEach((printerName) => {
            if (!linesByPrinter.has(printerName)) linesByPrinter.set(printerName, []);
            linesByPrinter.get(printerName).push(line);
        });
    }

    const targets = Array.from(linesByPrinter.entries()).map(([printerName, lines]) => ({
        printerName,
        content: lines.join('\r\n'),
    }));

    return { targets, unassigned };
};

const handlePrint = async (selectedTavolo, token = null, tenant = null, orderItems = null) => {
    if (!selectedTavolo && !Array.isArray(orderItems)) {
        return { success: false, error: 'Nessun tavolo o prodotti forniti' };
    }

    /**
     * // ciclo per controllare se i prodotti esistono e hanno un nome
        let tableProducts = '';
        for (const tp of mapProducts) {
            if (!tp.product || !tp.product.name) {
                return { success: false, error: 'Prodotto non valido trovato' };
            }
            tableProducts += `${tp.product?.name}     x${tp.quantity}`.join('\r\n');
        }
        console.log('ordine:', tableProducts);
        try {
            const payload = { roomId: roomId, content: tableProducts };
            const stampa = await printDocument(payload, authToken, authTenant);
            // printDocument dovrebbe ritornare { success: boolean, ... }
            return stampa;
        } catch (err) {
            const message = err?.message || String(err);
            console.error('Errore nella stampa della comanda:', message);
            return { success: false, error: message };
        }
    } catch (err) {
        const message = err?.message || String(err);
        console.error('Errore nella gestione della stampa:', message);
     */

    const authToken = token || localStorage.getItem('accessToken');
    const authTenant = tenant || localStorage.getItem('tenantId');

    // usa gli orderItems passati se presenti, altrimenti prendi dai orders del tavolo
    let mapProducts = [];
    if (Array.isArray(orderItems) && orderItems.length > 0) {
        mapProducts = orderItems;
    } else if (selectedTavolo) {
        const orders = selectedTavolo.ordersCreatedAt || [];
        mapProducts = orders
            .filter(order => order.status === 'CLOSED')
            .flatMap(order => order.orderProducts || []);
    }

        if (mapProducts.length === 0) {
            return { success: false, error: 'Nessun prodotto da stampare' };
        }

    const { targets, unassigned } = buildTargetsFromOrderItems(
        mapProducts,
        selectedTavolo?.roomId ?? selectedTavolo?.room?.id
    );
    if (unassigned.length > 0) {
        return { success: false, error: `Prodotti senza stampante associata: ${unassigned.slice(0, 5).join(', ')}` };
    }
    if (targets.length === 0) {
        return { success: false, error: 'Nessuna stampante articolo configurata' };
    }

    try {
        const payload = { targets, action: 'print' };
        const stampa = await printDocument(payload, authToken, authTenant);
        return stampa;
    } catch (err) {
        const message = err?.message || String(err);
        console.error('Errore nella stampa della comanda:', message);
        return { success: false, error: message };
    }
}

module.exports = { handlePrint };
